var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57451 13.998L6.57451 1.57079C6.57451 1.49222 6.51022 1.42793 6.43165 1.42793L5.3602 1.42793C5.2816 1.42793 5.2173 1.49222 5.2173 1.57079L5.2173 12.3783L1.9493 9.80144C1.8565 9.72822 1.7172 9.79429 1.7172 9.91394L1.7172 11.2086C1.7172 11.2961 1.7565 11.3783 1.8261 11.4336L5.6495 14.448C6.02449 14.7427 6.57451 14.4766 6.57451 13.998ZM10.7889 14.4284L10.7889 3.62086L14.0569 6.19774C14.1498 6.27096 14.2891 6.20488 14.2891 6.08523L14.2891 4.79055C14.2891 4.70304 14.2498 4.6209 14.1801 4.56554L10.3568 1.55115C9.98177 1.25649 9.43175 1.52258 9.43175 1.99938L9.43175 14.4284C9.43175 14.507 9.49604 14.5712 9.57461 14.5712L10.6461 14.5712C10.7247 14.5712 10.7889 14.507 10.7889 14.4284Z",
    fill: "#FCD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.c54758b19ded16968766b95da629361a.svg";
export { ForwardRef as ReactComponent };